export const docsPages = {
  "index": {
    "home": {
      "title": "Guide",
      "href": "https://docs.hatchet.run/home"
    },
    "self-hosting": {
      "title": "Self Hosting",
      "href": "https://docs.hatchet.run/self-hosting"
    },
    "contributing": {
      "title": "Contributing",
      "href": "https://docs.hatchet.run/contributing"
    },
    "cli": {
      "title": "CLI Reference",
      "href": "https://docs.hatchet.run/cli"
    },
    "agent-instructions": {
      "title": "Agent Instructions",
      "href": "https://docs.hatchet.run/agent-instructions"
    },
    "sdks": {
      "title": "SDK Reference",
      "href": "https://docs.hatchet.run/sdks"
    }
  },
  "home": {
    "index": {
      "title": "\ud83e\ude93 Welcome",
      "href": "https://docs.hatchet.run/home/index"
    },
    "architecture": {
      "title": "Architecture",
      "href": "https://docs.hatchet.run/home/architecture"
    },
    "guarantees-and-tradeoffs": {
      "title": "Guarantees & Tradeoffs",
      "href": "https://docs.hatchet.run/home/guarantees-and-tradeoffs"
    },
    "hatchet-cloud-quickstart": {
      "title": "Hatchet Cloud Quickstart",
      "href": "https://docs.hatchet.run/home/hatchet-cloud-quickstart"
    },
    "setup": {
      "title": "Advanced Setup",
      "href": "https://docs.hatchet.run/home/setup"
    },
    "coding-agents": {
      "title": "Using Coding Agents",
      "href": "https://docs.hatchet.run/home/coding-agents"
    },
    "your-first-task": {
      "title": "Tasks",
      "href": "https://docs.hatchet.run/home/your-first-task"
    },
    "workers": {
      "title": "Workers",
      "href": "https://docs.hatchet.run/home/workers"
    },
    "running-your-task": {
      "title": "Running Tasks",
      "href": "https://docs.hatchet.run/home/running-your-task"
    },
    "environments": {
      "title": "Environments",
      "href": "https://docs.hatchet.run/home/environments"
    },
    "running-tasks": {
      "title": "Running Tasks",
      "href": "https://docs.hatchet.run/home/running-tasks"
    },
    "run-with-results": {
      "title": "Run and Wait Trigger",
      "href": "https://docs.hatchet.run/home/run-with-results"
    },
    "run-no-wait": {
      "title": "Run Without Wait Trigger",
      "href": "https://docs.hatchet.run/home/run-no-wait"
    },
    "scheduled-runs": {
      "title": "Scheduled Trigger",
      "href": "https://docs.hatchet.run/home/scheduled-runs"
    },
    "cron-runs": {
      "title": "Cron Trigger",
      "href": "https://docs.hatchet.run/home/cron-runs"
    },
    "run-on-event": {
      "title": "Event Trigger",
      "href": "https://docs.hatchet.run/home/run-on-event"
    },
    "bulk-run": {
      "title": "Bulk Run Many",
      "href": "https://docs.hatchet.run/home/bulk-run"
    },
    "webhooks": {
      "title": "Webhooks",
      "href": "https://docs.hatchet.run/home/webhooks"
    },
    "inter-service-triggering": {
      "title": "Inter-Service Triggering",
      "href": "https://docs.hatchet.run/home/inter-service-triggering"
    },
    "docker": {
      "title": "Running with Docker",
      "href": "https://docs.hatchet.run/home/docker"
    },
    "troubleshooting-workers": {
      "title": "Troubleshooting",
      "href": "https://docs.hatchet.run/home/troubleshooting-workers"
    },
    "compute": {
      "title": "Managed Compute",
      "href": "https://docs.hatchet.run/home/compute",
      "index": {
        "title": "Overview",
        "href": "https://docs.hatchet.run/home/compute/index"
      },
      "getting-started": {
        "title": "Getting Started",
        "href": "https://docs.hatchet.run/home/compute/getting-started"
      },
      "cpu": {
        "title": "CPU Machine Types",
        "href": "https://docs.hatchet.run/home/compute/cpu"
      },
      "gpu": {
        "title": "GPU Machine Types",
        "href": "https://docs.hatchet.run/home/compute/gpu"
      },
      "git-ops": {
        "title": "GitOps",
        "href": "https://docs.hatchet.run/home/compute/git-ops"
      },
      "auto-scaling": {
        "title": "Auto Scaling",
        "href": "https://docs.hatchet.run/home/compute/auto-scaling"
      },
      "environment-variables": {
        "title": "Environment Variables",
        "href": "https://docs.hatchet.run/home/compute/environment-variables"
      }
    },
    "worker-healthchecks": {
      "title": "Worker Health Checks",
      "href": "https://docs.hatchet.run/home/worker-healthchecks"
    },
    "autoscaling-workers": {
      "title": "Autoscaling Workers",
      "href": "https://docs.hatchet.run/home/autoscaling-workers"
    },
    "concurrency": {
      "title": "Concurrency",
      "href": "https://docs.hatchet.run/home/concurrency"
    },
    "rate-limits": {
      "title": "Rate Limits",
      "href": "https://docs.hatchet.run/home/rate-limits"
    },
    "priority": {
      "title": "Priority",
      "href": "https://docs.hatchet.run/home/priority"
    },
    "orchestration": {
      "title": "Task Orchestration",
      "href": "https://docs.hatchet.run/home/orchestration"
    },
    "dags": {
      "title": "Directed Acyclic Graphs (DAGs)",
      "href": "https://docs.hatchet.run/home/dags"
    },
    "conditional-workflows": {
      "title": "Conditional Workflows",
      "href": "https://docs.hatchet.run/home/conditional-workflows"
    },
    "on-failure-tasks": {
      "title": "On Failure Tasks",
      "href": "https://docs.hatchet.run/home/on-failure-tasks"
    },
    "child-spawning": {
      "title": "Child Spawning",
      "href": "https://docs.hatchet.run/home/child-spawning"
    },
    "additional-metadata": {
      "title": "Additional Metadata",
      "href": "https://docs.hatchet.run/home/additional-metadata"
    },
    "durable-execution": {
      "title": "Durable Execution",
      "href": "https://docs.hatchet.run/home/durable-execution"
    },
    "durable-events": {
      "title": "Durable Events",
      "href": "https://docs.hatchet.run/home/durable-events"
    },
    "durable-sleep": {
      "title": "Durable Sleep",
      "href": "https://docs.hatchet.run/home/durable-sleep"
    },
    "durable-best-practices": {
      "title": "Best Practices",
      "href": "https://docs.hatchet.run/home/durable-best-practices"
    },
    "timeouts": {
      "title": "Timeouts",
      "href": "https://docs.hatchet.run/home/timeouts"
    },
    "retry-policies": {
      "title": "Retry Policies",
      "href": "https://docs.hatchet.run/home/retry-policies"
    },
    "bulk-retries-and-cancellations": {
      "title": "Bulk Retries and Cancellations",
      "href": "https://docs.hatchet.run/home/bulk-retries-and-cancellations"
    },
    "sticky-assignment": {
      "title": "Sticky Assignment",
      "href": "https://docs.hatchet.run/home/sticky-assignment"
    },
    "worker-affinity": {
      "title": "Worker Affinity",
      "href": "https://docs.hatchet.run/home/worker-affinity"
    },
    "manual-slot-release": {
      "title": "Manual Slot Release",
      "href": "https://docs.hatchet.run/home/manual-slot-release"
    },
    "logging": {
      "title": "Logging",
      "href": "https://docs.hatchet.run/home/logging"
    },
    "opentelemetry": {
      "title": "OpenTelemetry",
      "href": "https://docs.hatchet.run/home/opentelemetry"
    },
    "prometheus-metrics": {
      "title": "Prometheus Metrics",
      "href": "https://docs.hatchet.run/home/prometheus-metrics"
    },
    "cancellation": {
      "title": "Cancellation",
      "href": "https://docs.hatchet.run/home/cancellation"
    },
    "streaming": {
      "title": "Streaming",
      "href": "https://docs.hatchet.run/home/streaming"
    },
    "middleware": {
      "title": "Middleware & Dependency Injection",
      "href": "https://docs.hatchet.run/home/middleware"
    },
    "v1-sdk-improvements": {
      "title": "SDK Improvements",
      "href": "https://docs.hatchet.run/home/v1-sdk-improvements"
    },
    "migration-guide-engine": {
      "title": "Engine Migration Guide",
      "href": "https://docs.hatchet.run/home/migration-guide-engine"
    },
    "migration-guide-python": {
      "title": "Python Migration Guide",
      "href": "https://docs.hatchet.run/home/migration-guide-python"
    },
    "migration-guide-typescript": {
      "title": "Typescript Migration Guide",
      "href": "https://docs.hatchet.run/home/migration-guide-typescript"
    },
    "migration-guide-go": {
      "title": "Go Migration Guide",
      "href": "https://docs.hatchet.run/home/migration-guide-go"
    },
    "asyncio": {
      "title": "Asyncio",
      "href": "https://docs.hatchet.run/home/asyncio"
    },
    "pydantic": {
      "title": "Pydantic",
      "href": "https://docs.hatchet.run/home/pydantic"
    },
    "lifespans": {
      "title": "Lifespans",
      "href": "https://docs.hatchet.run/home/lifespans"
    },
    "dataclasses": {
      "title": "Dataclass Support",
      "href": "https://docs.hatchet.run/home/dataclasses"
    }
  },
  "cli": {
    "index": {
      "title": "Setup & Installation",
      "href": "https://docs.hatchet.run/cli/index"
    },
    "profiles": {
      "title": "Profiles",
      "href": "https://docs.hatchet.run/cli/profiles"
    },
    "running-hatchet-locally": {
      "title": "Running Hatchet Locally",
      "href": "https://docs.hatchet.run/cli/running-hatchet-locally"
    },
    "running-workers-locally": {
      "title": "Running Workers Locally",
      "href": "https://docs.hatchet.run/cli/running-workers-locally"
    },
    "triggering-workflows": {
      "title": "Triggering Workflows",
      "href": "https://docs.hatchet.run/cli/triggering-workflows"
    },
    "tui": {
      "title": "Using the Hatchet TUI",
      "href": "https://docs.hatchet.run/cli/tui"
    }
  },
  "sdks": {
    "python": {
      "title": "Python SDK",
      "href": "https://docs.hatchet.run/sdks/python",
      "client": {
        "title": "Client",
        "href": "https://docs.hatchet.run/sdks/python/client"
      },
      "context": {
        "title": "Context",
        "href": "https://docs.hatchet.run/sdks/python/context"
      },
      "feature-clients": {
        "title": "Feature Clients",
        "href": "https://docs.hatchet.run/sdks/python/feature-clients",
        "cron": {
          "title": "Cron",
          "href": "https://docs.hatchet.run/sdks/python/feature-clients/cron"
        },
        "filters": {
          "title": "Filters",
          "href": "https://docs.hatchet.run/sdks/python/feature-clients/filters"
        },
        "logs": {
          "title": "Logs",
          "href": "https://docs.hatchet.run/sdks/python/feature-clients/logs"
        },
        "metrics": {
          "title": "Metrics",
          "href": "https://docs.hatchet.run/sdks/python/feature-clients/metrics"
        },
        "rate_limits": {
          "title": "Rate Limits",
          "href": "https://docs.hatchet.run/sdks/python/feature-clients/rate_limits"
        },
        "runs": {
          "title": "Runs",
          "href": "https://docs.hatchet.run/sdks/python/feature-clients/runs"
        },
        "scheduled": {
          "title": "Scheduled",
          "href": "https://docs.hatchet.run/sdks/python/feature-clients/scheduled"
        },
        "workers": {
          "title": "Workers",
          "href": "https://docs.hatchet.run/sdks/python/feature-clients/workers"
        },
        "workflows": {
          "title": "Workflows",
          "href": "https://docs.hatchet.run/sdks/python/feature-clients/workflows"
        }
      },
      "runnables": {
        "title": "Runnables",
        "href": "https://docs.hatchet.run/sdks/python/runnables"
      }
    }
  },
  "self-hosting": {
    "index": {
      "title": "Introduction",
      "href": "https://docs.hatchet.run/self-hosting/index"
    },
    "hatchet-lite": {
      "title": "Hatchet Lite",
      "href": "https://docs.hatchet.run/self-hosting/hatchet-lite"
    },
    "docker-compose": {
      "title": "Docker Compose",
      "href": "https://docs.hatchet.run/self-hosting/docker-compose"
    },
    "kubernetes-quickstart": {
      "title": "Quickstart",
      "href": "https://docs.hatchet.run/self-hosting/kubernetes-quickstart"
    },
    "kubernetes-glasskube": {
      "title": "Installing with Glasskube",
      "href": "https://docs.hatchet.run/self-hosting/kubernetes-glasskube"
    },
    "networking": {
      "title": "Networking",
      "href": "https://docs.hatchet.run/self-hosting/networking"
    },
    "kubernetes-helm-configuration": {
      "title": "Configuring the Helm Chart",
      "href": "https://docs.hatchet.run/self-hosting/kubernetes-helm-configuration"
    },
    "kubernetes-external-database": {
      "title": "Setting up an External Database",
      "href": "https://docs.hatchet.run/self-hosting/kubernetes-external-database"
    },
    "high-availability": {
      "title": "High Availability",
      "href": "https://docs.hatchet.run/self-hosting/high-availability"
    },
    "configuration-options": {
      "title": "Engine Configuration Options",
      "href": "https://docs.hatchet.run/self-hosting/configuration-options"
    },
    "prometheus-metrics": {
      "title": "Prometheus Metrics",
      "href": "https://docs.hatchet.run/self-hosting/prometheus-metrics"
    },
    "worker-configuration-options": {
      "title": "Worker Configuration Options",
      "href": "https://docs.hatchet.run/self-hosting/worker-configuration-options"
    },
    "upgrading-downgrading": {
      "title": "Upgrading and Downgrading",
      "href": "https://docs.hatchet.run/self-hosting/upgrading-downgrading"
    },
    "downgrading-db-schema-manually": {
      "title": "Downgrading DB Schema Manually",
      "href": "https://docs.hatchet.run/self-hosting/downgrading-db-schema-manually"
    },
    "benchmarking": {
      "title": "Benchmarking",
      "href": "https://docs.hatchet.run/self-hosting/benchmarking"
    },
    "data-retention": {
      "title": "Data Retention",
      "href": "https://docs.hatchet.run/self-hosting/data-retention"
    },
    "improving-performance": {
      "title": "Improving Performance",
      "href": "https://docs.hatchet.run/self-hosting/improving-performance"
    },
    "read-replicas": {
      "title": "Read Replicas",
      "href": "https://docs.hatchet.run/self-hosting/read-replicas"
    },
    "sampling": {
      "title": "Trace Sampling",
      "href": "https://docs.hatchet.run/self-hosting/sampling"
    },
    "smtp-server": {
      "title": "SMTP Server",
      "href": "https://docs.hatchet.run/self-hosting/smtp-server"
    }
  },
  "contributing": {
    "index": {
      "title": "Contributing",
      "href": "https://docs.hatchet.run/contributing/index"
    },
    "github-app-setup": {
      "title": "GitHub App Setup",
      "href": "https://docs.hatchet.run/contributing/github-app-setup"
    },
    "sdks": {
      "title": "SDKs",
      "href": "https://docs.hatchet.run/contributing/sdks"
    }
  },
  "agent-instructions": {
    "setup-cli": {
      "title": "Setup CLI",
      "href": "https://docs.hatchet.run/agent-instructions/setup-cli"
    },
    "start-worker": {
      "title": "Start Worker",
      "href": "https://docs.hatchet.run/agent-instructions/start-worker"
    },
    "trigger-and-watch": {
      "title": "Trigger & Watch",
      "href": "https://docs.hatchet.run/agent-instructions/trigger-and-watch"
    },
    "debug-run": {
      "title": "Debug a Run",
      "href": "https://docs.hatchet.run/agent-instructions/debug-run"
    },
    "replay-run": {
      "title": "Replay a Run",
      "href": "https://docs.hatchet.run/agent-instructions/replay-run"
    }
  }
} as const;
